import { notification_color_keys, useNotifications } from "utils/hooks";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { GET_CUSTOM_COLUMN } from "../constants/CustomColumns.api";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { getCustomColumnQueryKey } from "./customColumnQueryKeys";
import { useCrmStore } from "features/Crm/store/useCrmStore";

export const useGetCustomColumns = ({ params }) => {
  const { notify } = useNotifications();
  const setCustomColumnsMasterObj = useCrmStore(
    (state) => state.setCustomColumnsMasterObj
  );

  return useCustomQuery({
    url: GET_CUSTOM_COLUMN,
    queryKey: getCustomColumnQueryKey(params),
    params,
    onSuccess: (data) => {
      setCustomColumnsMasterObj({
        value: data?.custom_columns,
        featureKey: params?.section_name,
      });
    },
    onError: (err) => {
      notify(
        err?.response?.data?.message || SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    },
  });
};
